import PropTypes from 'prop-types';

import BrIcons from '@components/BrIcons';
import ColorStyles from '@components/ColorStyles';
import BrTooltip from '@components/BrTooltip';

export default function DeletableLinkColumn({ row, col, cell }) {
  const { isTruncated, isExternal, onDelete } = col.columnConfig;
  const { isReadOnly, readOnlyTooltip } = row;
  const { value } = cell;
  const clickValue = cell.clickValue || value;
  const displayValue = !isTruncated ? value : value.substring(value.indexOf('/', 10));

  const readOnlyDCNote = isReadOnly && (
    <BrTooltip className="read-only-label" location={BrTooltip.Locations.right}>
      <BrIcons.ReadOnly />
      <BrTooltip.Tooltip>{readOnlyTooltip}</BrTooltip.Tooltip>
    </BrTooltip>
  );

  return (
    <div className="deletable-link-column">
      {cell.prefixElement ? cell.prefixElement : null}
      {readOnlyDCNote}
      <a dir="auto" onClick={() => col.columnConfig.onClick(row, clickValue)}>
        {displayValue}
      </a>
      {cell.suffixElement ? cell.suffixElement : null}
      {isExternal && (
        <a href={value} target="_blank" rel="noreferrer">
          <BrIcons.Extlink colorStyle={ColorStyles.BLUE} />
        </a>
      )}
      <div className="flexdiv" />
      {onDelete && <BrIcons.Delete className="del-row-icon" onClick={() => onDelete(row, clickValue)} />}
    </div>
  );
}

DeletableLinkColumn.propTypes = {
  col: PropTypes.shape({
    columnConfig: PropTypes.shape({
      isTruncated: PropTypes.bool, // for url link value, truncate on first slash after the double slash
      isExternal: PropTypes.bool, // display external link icon, uses cell.value as link href
      onClick: PropTypes.func.isRequired, // (row, value) :=> {}
      onDelete: PropTypes.func, // (row, value) :=> {}  the delete icon will not be shown if this func not provided
    }).isRequired,
  }).isRequired,
  cell: PropTypes.shape({
    value: PropTypes.string.isRequired, // display text
    clickValue: PropTypes.any, // value will be used if clickValue not provided
    prefixElement: PropTypes.element, // any HTML element you want to show before the text
    suffixElement: PropTypes.element, // HTML element you want to show after the text
  }).isRequired,
};
